import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52a33a6e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=52a33a6e&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=52a33a6e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a33a6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a33a6e')) {
      api.createRecord('52a33a6e', component.options)
    } else {
      api.reload('52a33a6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52a33a6e&scoped=true", function () {
      api.rerender('52a33a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/integral/pointsActivity/index.vue"
export default component.exports